<div class="loading" *ngIf="visible" [class.non-blocking]="!blockUI">
    <div class="loading-overlay">
        <div class="loading-content">
            <p-progressSpinner ariaLabel="loading" />
            <span>{{ label }}</span>
        </div>
    </div>
</div>
